export default {
  REACT_APP_FIREBASE_API_KEY: "AIzaSyASak1Tm4rt3zaCtxAzUhCnNq4xNm4BmvI",
  REACT_APP_FIREBASE_AUTH_DOMAIN: "marioplan-main.firebaseapp.com",
  REACT_APP_FIREBASE_PROJECT_ID: "marioplan-main",
  REACT_APP_FIREBASE_STORAGE_BUCKET: "marioplan-main.appspot.com",
  REACT_APP_FIREBASE_MESSAGINF_SENDER_ID: "94164734057",
  REACT_APP_FIREBASE_APP_ID: "1:94164734057:web:53cd2d6c7fd55f8c86d2f8",
  REACT_APP_FIREBASE_MEASUREMENT_ID: "G-FTEXX2GNTZ",
};
